import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import {
  createColumn,
  createViewEdit,
  formatDateTime,
  getForm,
  getRegister,
  stringifyName,
} from "../../utils/helpers";
import { URL_VEHICLE_TYPES } from "../../utils/urls";
import useGet from "../common/useGet";
import { API_DISTRICTS, API_VEHICLE_TYPES_CREATE } from "../../utils/apis";
import { IFormSection } from "../../types/common";

export const useVehicleTypes = () => {
  const tableColumns = () => [
    {
      id: "name",
      header: "Name",
      filter: true,
    },
    {
      id: "city_name",
      header: "City",
      filter: true,
    },
    ...["created_at", "actions"].map((item) => createColumn(item)),
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        created_at: formatDateTime(item.created_at),
        actions: (
          <FormActions
            actions={createViewEdit(URL_VEHICLE_TYPES, item?.id, true)}
          />
        ),
      };
      return row;
    }),
  ];

  const viewData = (item: any) => {
    return {
      name: item?.name,
      city: item?.city_name,
      created_at: formatDateTime(item?.created_at),
      created_by: stringifyName({ ...item?.created_by }),
    };
  };

  const formRoute = getForm(URL_VEHICLE_TYPES);

  return {
    tableColumns,
    tableData,
    viewData,
    formRoute,
  };
};

export const useVehicleTypesForm = () => {
  const { data, loading, error } = useGet();

  const {
    loadData: loadDistricts,
    loading: loadingDistricts,
    data: districts,
  } = useGet();

  useEffect(() => {
    loadDistricts({ api: API_DISTRICTS });
  }, []);

  const sections: IFormSection[] = [
    {
      title: "Vehicle Type Details",
      fields: [
        {
          field_name: "name",
          type: "text",
          label: "Vehicle Type Name",
          props: { required: true },
        },
        {
          field_name: "city_name",
          label: "City",
          type: "select",
          props: {
            required: true,
            placeholder: "Select City",
            options:
              districts?.map((district: any) => ({
                value: district.id,
                label: district.name,
              })) || [],
          },
        },
      ],
    },
  ];

  const redirect = getRegister(URL_VEHICLE_TYPES);

  return {
    data,
    loading,
    error,
    districts,
    loadingDistricts,
    sections,
    redirect,
  };
};

export function submitVehicleTypes(payload: any, id: string) {
  // on update
  if (id) {
    return {
      id,
      api: API_VEHICLE_TYPES_CREATE,
      params: { key: payload?.key, name: payload?.name },
    };
  }
  // on create
  return {
    api: API_VEHICLE_TYPES_CREATE,
    params: payload,
  };
}
